module.exports = __webpack_public_path__ + "static/media/ourwork.f428900b.jpg";